import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import find from 'lodash/find'
import { bindActionCreators } from 'redux'
import { actionCreators } from 'reduxBits/toplistings'
import isEqual from 'lodash/isEqual'
import queryString from 'query-string'

import ToplistingCarousel from 'components/ToplistingCarousel'
import ToplistAdItem from './ToplistAdItem'
import ToplistPlacementItem from './ToplistPlacementItem'
import BostadAd from './BostadAd'

const getToplistingComponent = (item) => {
  switch (item.type) {
    case 'ad':
      return <ToplistAdItem key={item.ad.clickUrl} {...item.ad} />
    case 'placement':
      return <ToplistPlacementItem key={item.placement.clickUrl} {...item.placement} />
    case 'veckans_bostad':
    case 'manadens_nyproduktion':
      return <BostadAd key={item.bostadAd.clickUrl} {...item.bostadAd} />
    default:
      return null
  }
}

class Toplistings extends React.Component {
  componentDidMount() {
    this.fetchToplistings(this.props.location.search)
  }

  componentDidUpdate(nextProps) {
    if (isEqual(this.props.location.search, nextProps.location.search)) {
      return
    }
    this.fetchToplistings(this.props.location.search)
  }

  fetchToplistings = (searchString) => {
    const { actions } = this.props
    actions.fetchToplistings(queryString.parse(searchString))
  }

  trackImpression = (currentSlideIndex) => {
    const { listings } = this.props
    const data = find(listings[currentSlideIndex], 'impressionUrl')
    if (data) {
      fetch(data.impressionUrl).catch(() => {})
    }
  }

  render() {
    const { listings = [], isFetching, error } = this.props
    if (error) {
      return null
    }

    const slickSettings = {
      afterChange: this.trackImpression,
      onInit: () => this.trackImpression(0),
    }

    return (
      !isFetching && (
        <ToplistingCarousel slickSettings={slickSettings}>
          {listings.map(getToplistingComponent)}
        </ToplistingCarousel>
      )
    )
  }
}

const mapStateToProps = (state) => ({
  error: state.toplistings.error,
  listings: state.toplistings.data,
  isFetching: state.toplistings.isFetching,
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})

Toplistings.propTypes = {
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  actions: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  listings: PropTypes.array,
  isFetching: PropTypes.bool.isRequired,
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Toplistings),
)
